import { Box } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { Concepts } from 'modules/finance/components/FinancialWorkspace/components/Settings/Concepts'

import { FinancialWorkspaceSettingsFormValues } from './constants'

interface SettingsFormFieldsProps {
  setFieldValue: (field: keyof FinancialWorkspaceSettingsFormValues, value: number[]) => void
  defaultConceptIdsToAdd: number[]
  defaultConceptIdsToSubtract: number[]
  setExpensesConceptDetected: (detected: boolean) => void
}

export const SettingsFormFields = ({
  setFieldValue,
  defaultConceptIdsToAdd,
  defaultConceptIdsToSubtract,
  setExpensesConceptDetected,
}: SettingsFormFieldsProps) => {
  return (
    <Box width="full" gap="s16">
      <Concepts
        title={i18n.t('finance.financial_workspace.settings.labor_cost.add_to_total.title')}
        description={i18n.t(
          'finance.financial_workspace.settings.labor_cost.add_to_total.description_v2'
        )}
        defaultConceptIds={defaultConceptIdsToAdd}
        field="conceptIdsToAdd"
        setFieldValue={setFieldValue}
      />

      <Concepts
        title={i18n.t('finance.financial_workspace.settings.labor_cost.subtract_from_total.title')}
        description={i18n.t(
          'finance.financial_workspace.settings.labor_cost.subtract_from_total.description_v2'
        )}
        defaultConceptIds={defaultConceptIdsToSubtract}
        field="conceptIdsToSubtract"
        setFieldValue={setFieldValue}
        setExpensesConceptDetected={setExpensesConceptDetected}
      />
    </Box>
  )
}
